import React, { useState, useEffect } from 'react';

import { convertFromSeconds, convertToSeconds } from './TimeUtils';

const TransitionTime = ({ number, defaultValue, callback }) => {
    const [time, setTime] = useState(convertFromSeconds(defaultValue));

    const updateTime = value => {
        setTime(value);

        const seconds = convertToSeconds(value);

        if (seconds > 0) {
            callback(`t${number}`, seconds);
        }
    }

    return (
        <div>
            <h2>Transition {number} time</h2>
            <label>
                <p>Enter your time in m:ss format</p>
                <input
                    type="text"
                    value={time}
                    onChange={event => updateTime(event.target.value)}
                />
            </label>
        </div>
    );
};

export default TransitionTime;
